import { Flex, Grid, Image, useDisclosure } from '@chakra-ui/react';
import React from 'react';
import { IconAssets } from 'src/config';
import { Color } from 'src/theme/color';

export const DropdownItem = ({ children, heading }: { children: React.ReactNode; heading: string }) => {
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<Grid
			borderRadius="4px"
			overflow="hidden"
			templateRows="1fr auto"
			bg={Color.GRAY_4}
		>
			<Flex
				cursor="pointer"
				p="10px 30px"
				align="center"
				onClick={isOpen ? onClose : onOpen}
				justifyContent="space-between"
			>
				{heading}
				<Image
					w="14px"
					transform={`rotate(${isOpen ? 180 : 0}deg)`}
					src={IconAssets.chevronDown}
				></Image>
			</Flex>
			{isOpen ? (
				<Flex
					p="30px 30px"
					bg={Color.BLACK_4}
				>
					{children}
				</Flex>
			) : null}
		</Grid>
	);
};
